import styled from 'styled-components';
import { lighten } from 'polished';

import { color } from '../../styles/global';

export const Container = styled.div`
    width: 100%;
    margin: 15px;
    display: flex;
    align-items: center;
    justify-content: center;

    ul {
        display: flex;
        list-style: none;
        margin: 15px;
    }

    button {
        width: 25px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 1px;
        background: none;
        border: 1px solid ${lighten(0.3, color.primary)};
        color: ${lighten(0.3, color.primary)};
        cursor: pointer;
        line-height: 21px;
    }
`;
